/* === SOS AUTO: akceptacja regulaminu montażu w koszyku (Claude edit) === */
(function () {
    function initCartPageGate() {
        var checkbox = document.getElementById('MontazRegulaminCheckbox');
        var cartForm = document.getElementById('cart_form');
        if (!checkbox || !cartForm) { return; }
        var checkoutBtn = cartForm.querySelector('button[name="checkout"]');
        var card = checkbox.closest('.cart-montaz-acceptance');
        var errorEl = card ? card.querySelector('.claude-montaz-error') : null;
        if (!checkoutBtn) { return; }

        checkoutBtn.addEventListener('click', function (e) {
            if (!checkbox.checked) {
                e.preventDefault();
                if (errorEl) { errorEl.style.display = 'block'; }
                if (card) {
                    card.classList.add('claude-montaz-shake');
                    setTimeout(function () { card.classList.remove('claude-montaz-shake'); }, 400);
                    card.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            }
        });

        checkbox.addEventListener('change', function () {
            if (checkbox.checked && errorEl) { errorEl.style.display = 'none'; }
        });
    }

    function initPopupGuard() {
        var popupForm = document.getElementById('cart-popup-form');
        if (!popupForm) { return; }

        popupForm.addEventListener('submit', function (e) {
            e.preventDefault();
            fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
                .then(function (res) { return res.json(); })
                .then(function (cart) {
                    var items = cart && cart.items ? cart.items : [];
                    var hasMontaz = items.some(function (item) {
                        return item.variant_title && item.variant_title.toLowerCase().indexOf('montażem') !== -1;
                    });
                    if (hasMontaz) {
                        window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart';
                    } else {
                        popupForm.submit();
                    }
                })
                .catch(function () {
                    popupForm.submit();
                });
        });
    }

    function init() {
        initCartPageGate();
        initPopupGuard();
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
